import { Component, OnInit,ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatCheckboxChange,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MessagesGeneral, MessagesTitles,MessagesStatus,MessagesDates } from '../../../models/messages';
import { FormControl, FormGroup} from '@angular/forms';
import Swal from "sweetalert2";
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FiltrosPagoLiquidacion } from '../../../models/FiltrosPagoLiquidacion';
import { DatePipe} from "@angular/common";
import { Router} from '@angular/router';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { LiquidacionService } from '../../../services/liquidacion/liquidacion.service';
import { LoginService } from "app/services/login/login.service";
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;
@Component({
  selector: 'app-nueva-liquidacion',
  templateUrl: './nueva-liquidacion.component.html',
  styleUrls: ['./nueva-liquidacion.component.scss'],
  providers:[MessagesTitles,MessagesGeneral, MessagesStatus,MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})

export class NuevaLiquidacionComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  abrirPopUp:boolean = false;
  monedaElement :any;
  loading:boolean ;
  checkboxStates = {}
  idProvedor :any;
  idAdquirente :any;
  proveedoresArr:any;
  adquirentesArr:any;
  respPagoLiquidacion:any = [];
  ruc = new FormControl();
  rucAdq = new FormControl();
  filteredProveeedor: Observable<any[]>;
  filteredAdquirente: Observable<any[]>;

  arraySend: any = [];

  body: any = {
    usuario: "",
    canal: "W",
    idComprobante: 0
  };

  fechaPago: Date = new Date();
  
  dataLiquidacion: any = [];
  datosEnviar: any = [];
  user:any;
  DTOFiltrosPagoLiqui:FiltrosPagoLiquidacion = new FiltrosPagoLiquidacion();
  rucAdqFilter = new FormControl('');
  rucProvFilter = new FormControl('');
  dataFiltro : FormGroup;
  
  displayedColumns = ['checked','docNeg', 'Proveedor','Adquirente','Moneda','VNPP','Importe_Ejecutado','Importe_Pendiente','Importe_Ajuste','Fecha_de_Pago','Fecha_de_Pago_Real','Estado'];
  dataSource: any = [];
  pageSizeOptions = [10,20,30,50,100,200];

  filterValues = {
    Adquirente: '',
    Moneda: '',
    Proveedor:''
    }; 

  constructor(private liquidacionService:LiquidacionService,
             private router:Router,
             private msgTitulos : MessagesTitles,
             private msgStatus:MessagesStatus,
             private loginService:LoginService) {
              this.dataFiltro = new FormGroup({
                "Moneda":new FormControl(0),
                "Fecha_Inicio": new FormControl(''),
                "Fecha_Fin": new FormControl(''),
                "Estado":new FormControl('')
              });  
              this.user = JSON.parse(sessionStorage.getItem('UserActive'));
              this.fechaPago.setDate(this.fechaPago.getDate()-1);
              this.ObtenerAdquirentesCombo();
              this.ObtenerProveedoresCombo() 
              }

  ngOnInit() {
    this.DTOFiltrosPagoLiqui.Moneda = this.Label_id_soles;
    this.monedaElement = this.Label_id_soles;
    this.body.usuario = this.user.Usuario;
    this.obtenerDocumentosPagados();

    this.rucAdqFilter.valueChanges
    .subscribe(
      Adquirente => {
        this.filterValues.Adquirente = Adquirente;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
    this.rucProvFilter.valueChanges
    .subscribe(
      Proveedor => {
        this.filterValues.Proveedor = Proveedor;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
    this.dataFiltro.get('Moneda').valueChanges
      .subscribe(
        Moneda => {
          this.filterValues.Moneda = Moneda;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
    )
  }

  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.Adquirente.toString().toLowerCase().indexOf(searchTerms.Adquirente) !== -1
      && data.Proveedor.toString().toLowerCase().indexOf(searchTerms.Proveedor) !== -1
      && data.Moneda.toString().toLowerCase().indexOf(searchTerms.Moneda) !== -1 
    }
  }

  obtenerDocumentosPagados(){
    this.loading = true;
    this.liquidacionService.obtenerDocumentosPagados().subscribe( 
      resp => {
        this.respPagoLiquidacion = resp      
        this.dataSource = new MatTableDataSource(this.respPagoLiquidacion);        
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.loading = false;
      },
      err => {
        console.log("error",err);
        this.loading = false;

        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Error al intentar obtener listado",
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      });
  }  

  limpiar(){
    if(this.arraySend.length == 0){
      this.respPagoLiquidacion.map(object => object.checked = true);
      this.arraySend = this.respPagoLiquidacion;
    } else {
      this.arraySend = [];
      this.respPagoLiquidacion.map(object => object.checked = false);
    }
  }

  Agregar(element: any){
    if(element.checked){
      this.arraySend.push(element);
    } else {
      this.arraySend = this.arraySend.filter(function(dato){
        if (dato.idComprobante == element.idComprobante) {
          return false;
        } else {
          return true;
        }
      })
    }   
  }

  crearLiquidacion(){
    if(this.arraySend.length>0){
      Swal.fire({
        title: 'Liquidación de documentos',
        html: '¿Deseas liquidar <b>'+this.arraySend.length+'</b> documento(s)?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Sí',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        heightAuto: false
      }).then((result) => {
        if (result.value) {
          this.agregarbody();
        }
      })
    } else {
        Swal.fire({
          title: 'Espera',
          text: 'Seleccione al menos un documento.',
          type: 'warning',
          heightAuto: false
        })
    }  
  }

  agregarbody(){
    this.loading = true;
          this.loginService.clickGuard = true;
          let total = this.arraySend.length;
          let ini = 0;
          this.arraySend.forEach(element => {
            this.body.idComprobante = element.idComprobante;
            this.liquidacionService.crearLiquidacion(this.body).subscribe(
              resp =>{
                this.showNotification('success','top','right','Documento Nro '+element.idComprobante+' liquidado satisfactoriamente.');
                ini++;
                if(ini == total) this.router.navigate(['/liquidacion/liquidaciones/listado']);
              },err => {
                let error = "";
                error = err.error.error;
                this.showNotification('warning','top','right','No se pudo liquidar el documento Nro '+element.idComprobante+'. \n Error: ' + error);
                ini++;
                if(ini == total) this.router.navigate(['/liquidacion/liquidaciones/listado']);
              }
            )
          })
  }
  showNotification(type,from,align,message){
    
    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

  tipoMoneda(event){
    if(event==''){
      this.dataFiltro.controls['Moneda'].setValue('')
    }else{
      this.dataFiltro.controls['Moneda'].setValue(event)
    } 
  }

  obtenerRucRazSocialAdq(termino :string = ''){  
    if (termino != null && termino != ''){      
      let termino1 = termino.toLowerCase();                   
      for( let p of this.adquirentesArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){         
            this.idAdquirente = p.idEmpresa;
          }
      }
    }
  }
  
  obtenerRucRazSocialProv(termino :string = ''){
    if (termino != null && termino != ''){        
      let termino1 = termino.toLowerCase();                   
      for( let p of this.proveedoresArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){     
            this.idProvedor = p.idEmpresa;
            this.DTOFiltrosPagoLiqui.idProveedor = p.idEmpresa;
          }
      }
    }
  }

  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
      this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      ); 
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  ObtenerAdquirentesCombo() {
      this.adquirentesArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
      this.filteredAdquirente = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAdq(state) : this.adquirentesArr.slice()
        )
      ); 
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentesArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  obtenerIdProv(termino :string){
    this.idProvedor = termino;
    this.DTOFiltrosPagoLiqui.idProveedor = termino;
  }

  
  obtenerIdAdq(termino :string){
    this.idAdquirente = termino;
  }

  changeCheckBoxesStatus(e: MatCheckboxChange) {
    if (e.checked) {
      Object.keys(this.checkboxStates).forEach(key => {
        this.checkboxStates[key] = true;
      })
    } else {
      Object.keys(this.checkboxStates).forEach(key => {
        this.checkboxStates[key] = false;
      })
    }
  }

  Liquidar(){

   this.datosEnviar=[];


    this.respPagoLiquidacion.forEach(item => { 
      if  (this.checkboxStates[item.idComprobante]){
       this.datosEnviar.push(item)   
        }    
      });
    if (this.datosEnviar.length == 0) {
      Swal.fire({
        title: "Warning",
        text: "seleccione al menos 1 check",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
        })
        return;
    }

      this.liquidacionService.arrayLiquidacion = this.datosEnviar;
    this.abrirPopUp = true;
  }

  CerrarPopUp(){
    this.abrirPopUp = false;
  }

}
